import { useState, useEffect, useRef } from "react";
import { RichText } from "prismic-reactjs";
import { linkResolver } from "../utils/link-resolver";
import t from "typy";
import styled from "styled-components";
import { themeGet } from "styled-system";
import { Text } from "rebass";
import { theme } from "../styles/theme";

const WYSIWYG = ({ content, handleDangerously }) => {
  let contentTargetBlank;
  if (handleDangerously) {
    contentTargetBlank = content.replace(
      /<a href=/gi,
      "<a target='_blank' href="
    );
  }

  const [richTextReady, setRichTextReady] = useState(false)
  const richTextRef = useRef(null);

  useEffect(() => {
    if (!handleDangerously && t(richTextRef, 'current.innerHTML').isDefined) {
      const inner = richTextRef.current.innerHTML;
      const regex = /CO2/g;
      const newInner = inner.replace(regex, 'CO<sub>2</sub>');
      richTextRef.current.innerHTML = newInner;
    }

    setTimeout(() => {
      setRichTextReady(true)
    }, 5)
  }, []);

  return (
    <S_Text ready={richTextReady} fontSize={[2, 2, 2, 3]} lineHeight={1.5555555556} ref={richTextRef}>
      {handleDangerously ? (
        <NewsContent dangerouslySetInnerHTML={{ __html: contentTargetBlank }} />
      ) : (
        RichText.render(content, linkResolver)
      )}
    </S_Text>
  );
};

const NewsContent = styled.div`
  img {
    width: 100%;
  }

  .textImage {
    float: none;
    margin: ${themeGet("space.3")}px 0;

    @media screen and (min-width: ${theme.breakpoints[0]}) {
      margin: 0;
      padding-top: ${themeGet("space.2")}px;
    }
  }

  .textImage-right:not(.textImage-large):not(.textImage-large_uncropped) {
    @media screen and (min-width: ${theme.breakpoints[0]}) {
      float: right;
      padding-left: ${themeGet("space.3")}px;
    }
  }

  .textImage-left:not(.textImage-large):not(.textImage-large_uncropped) {
    @media screen and (min-width: ${theme.breakpoints[0]}) {
      float: left;
      padding-right: ${themeGet("space.3")}px;
    }
  }

  .textImage-large {
    width: 100%;
    /* Hide '<div>&nbsp;</div>' that follows .textImage-large */
    & ~ div {
      display: none;
    }
  }

  .textImage-large_uncropped {
    @media screen and (min-width: ${theme.breakpoints[0]}) {
      width: 50%;
      float: right;
      padding-left: ${themeGet("space.3")}px;
    }
  }

  .textImage-creditBody {
    text-align: right;
    font-size: ${themeGet("fontSizes.0")}px;
    @media screen and (min-width: ${theme.breakpoints[3]}) {
      font-size: ${themeGet("fontSizes.1")}px;
    }
  }

  .textImage-captionBody {
    font-family: ${themeGet("fonts.regularItalic")};
    font-size: ${themeGet("fontSizes.2")}px;
    @media screen and (min-width: ${theme.breakpoints[3]}) {
      font-size: ${themeGet("fontSizes.3")}px;
    }
  }
`;

const S_Text = styled(Text)`
  opacity: ${props => props.ready ? 1 : 0};
  transition: opacity 0.2s ease;

  p {
    margin: 30px 0;
  }

  p:first-child {
    margin-top: 0;
  }

  p:last-child {
    margin-bottom: 0;
  }

  ol {
    padding-left: 0;
    margin-left: 25px;

    li {
      list-style-position: outside;
      padding-left: 10px;

      &:not(:first-of-type) {
        margin-top: 40px;
      }
    }
  }

  ul {
    margin-left: 35px;
    li {
      position: relative;
      &:not(:first-of-type) {
        margin-top: 40px;
      }
      &::before {
        content: "●";
        color: currentColor;
        font-size: 1.5em;
        line-height: 0;
        left: -35px;
        top: 15px;
        position: absolute;
      }
    }
  }

  a {
    text-decoration: underline;
  }

  @media screen and (max-width: ${theme.breakpoints[3]}) {
    /* Scale embed videos to ~16:9 aspect ratio */
    div[data-oembed-type="video"] {
      > div {
        position: relative;
        width: 100%;
        height: 0;
        padding-bottom: 56%;
        > iframe {
          position: absolute;
          width: 100%;
          height: 100%;
          left: 0;
          top: 0;
        }
      }
    }
  }

  @media screen and (max-width: ${theme.breakpoints[2]}) {
    p {
      margin: 15px 0;
    }
  }

  @media screen and (max-width: ${theme.breakpoints[1]}) {
    img {
      width: 100%;
      height: auto;
    }

    ol {
      margin-left: 15px;
      li {
        padding-left: 15px;
        &:not(:first-of-type) {
          margin-top: 20px;
        }
      }
    }

    ul {
      margin-left: 30px;
      li {
        &:not(:first-of-type) {
          margin-top: 20px;
        }
        &::before {
          left: -30px;
          top: 10px;
        }
      }
    }
  }
`;

export { WYSIWYG };
